<template>
  <keep-alive :include="cacheList">  
    <router-view>
      <slot class="content-header" name="content-header">
        <div class="content-search">
          <i data-feather="search"></i>
          <input type="search" class="form-control" placeholder="Search...">
        </div>
        <nav class="nav">
          <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
          <a href="" class="nav-link"><i data-feather="grid"></i></a>
          <a href="" class="nav-link"><i data-feather="align-left"></i></a>
        </nav> 
      </slot>
    </router-view>
  </keep-alive>
</template>

<script>

import { hasOneOf } from "@/libs/tools";
import { mapActions } from "vuex";

export default {
  name: "Main",
  components: {

  },
  data: () => ({
    showHomePage: false,
  }),
  mounted() {
  },
  computed:{
    cacheList() {
      return [
        "ParentView", ...([])
      ];
    },
    LocalComposeComp() {
      return this.$store.state.app.localCompose.isShow;
    },
  },
  methods:{
    ...mapActions([
      "handleLocalMailCompose",
    ]),
    hasPermission(arr){
      if(this.$store.state.user.userId=='')
      return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    hideLocalMailCompose() {    
      let obj = this.$store.state.app.localCompose;
      obj.isShow = false;
      obj.taskIds = [];
      obj.attachIds = [];
      obj.userIds = [];
      this.handleLocalMailCompose(obj);
    },
  },
};
</script>
